import React, { Children, createElement } from "react";
import './index.scss';
import ColorfulCol from "./colorful-col";
const ColorfulRow = function ColorfulRow({ children, cols, onClick, ...otherProps }) {
    const _otherProps = otherProps || {};
    let childrenToRender = children;
    if (cols && cols.length > 0) {
        childrenToRender = cols.map((option, i) => {
            return (createElement(ColorfulCol, { ...option }, option?.children || ''));
        });
    }
    return (createElement("div", { className: `au-row`, ..._otherProps }, Children.map(childrenToRender, (child, index) => {
        return React.cloneElement(child, {
            index,
            width: child.props?.width || 1,
        });
    })));
};
ColorfulRow.displayName = 'ColorfulRow';
export default ColorfulRow;
